import { Image, ImageKeys } from '@components/image';
import { Typography } from '@leegality/leegality-react-component-library';
import { getTranslation } from '@utils';
import React, { useCallback } from 'react';

const CONSENT_IN_URL = 'https://consent.in/';

const SecuredByContent = () => {
  const handleConsentInClick = useCallback(() => {
    window.open(CONSENT_IN_URL, '_blank');
  }, []);

  return (
    <div className="flex justify-center items-center text-xs text-center text-gray-700">
      <Typography
        tag={Typography.Tags.p}
        variant={Typography.Variants.xxs}
        fontWeight={Typography.FontWeight.medium}
        color={Typography.Colors.gray600}
      >
        {getTranslation('SECURED_BY_LABEL')}
      </Typography>
      <Image
        imgKey={ImageKeys.ConsentIn}
        width={57}
        height={8}
        className="h-2 w-[57px] ml-1 cursor-pointer"
        onClick={handleConsentInClick}
      />
    </div>
  );
};

export default SecuredByContent;
